import routes from 'routes'
import { Pages } from 'routes/types'

export const feedbackList = {
  SETTLEMENT_NOT_HAPPENING: 'Settlement is not happening/Delayed',
  BATTERY_ISSUE: 'Battery Issue',
  NETWORK_ISSUE: 'Network Issue',
  DEVICE_NOT_TURNING_ON: 'Device not turning on/Dead',
  CARD_NOT_WORKING: 'Card is not working',
  PQR_NOT_WORKING: 'PQR is not working/Torn',
  DEVICE_DAMAGED: 'Device is damaged',
  SHOP_CLOSED: 'Shop Closed/Merchant out of Station',
  NO_ISSUES: 'No issue found/Merchant is happy',
  USING_COMPETITION_QR: 'Using competition QR',
  EXTRA_AMOUNT_MDR_DEDUCTED: 'Extra/Wrong Extra amount MDR deducted',
  WRONG_COMMITED_BY_SALES: 'Wrong committed by FOS/Sales',
}

export const resolutionList = {
  EXPLAINED_RESOLVED_SETTLEMENT: 'Explained & Resolved settlement issues',
  REBOOTED_DEVICE_RESOLVED: 'Rebooted device and resolved',
  MERCHANT_AGREED_TRANSACTIONS: 'Merchant agreed to take transactions',
  TICKET_RAISED_PINE_ASSIST: 'Ticket raised through Pine Assist',
  TICKET_RAISED_PINE_ONE: 'Ticket raised through Pine One',
  NEW_QR_PROVIDED: 'New QR provided',
  REMOVED_COMPETITION_QR: 'Removed competition QR',
}

export const REVISIT_STATUS = {
  // open
  REVISIT_INITIATED: 'REVISIT_INITIATED',
  LOCATION_DISCREPANCY_VALIDATED: 'LOCATION_DISCREPANCY_VALIDATED', // open
  FEEDBACK_SUBMITTED: 'FEEDBACK_SUBMITTED',
  OPPORTUNITY_SF_SYNC_FAILED: 'OPPORTUNITY_SF_SYNC_FAILED',
  PO_IMS_FAILED: 'PO_IMS_FAILED',
  DEPLOYMENT_CASE_CREATION_FAILED: 'DEPLOYMENT_CASE_CREATION_FAILED',
  PRODUCTS_CONSUMPTION_PENDING: 'PRODUCTS_CONSUMPTION_PENDING',
  ACTIVATION_IN_PROGRESS: 'ACTIVATION_IN_PROGRESS',
  ACTIVATION_AND_MAPPING_COMPLETED: 'ACTIVATION_AND_MAPPING_COMPLETED',
  PHOTO_PROOFS_UPLOADED: 'PHOTO_PROOFS_UPLOADED',
  // open end

  // resolved
  REVISIT_COMPLETED: 'REVISIT_COMPLETED',
  REVISIT_INCOMPLETE: 'REVISIT_INCOMPLETE',
  // resolved end

  // rescheduled
  REVISIT_RESCHEDULED: 'REVISIT_RESCHEDULED',
  // rescheduled end
}

export const GetAllRevisitStatuses = (exclude?: string) => {
  return Object.keys(REVISIT_STATUS)
    .filter((key) => key !== exclude)
    .map((key) => REVISIT_STATUS[key])
}

export const RevisitCloseReasons = {
  MERCHANT_NOT_AVAILABLE: 'Merchant not available on mobile number',
  MERCHANT_LOCATION_INCORRECT: 'Merchant Location is Incorrect',
  MERCHANT_NOT_INTERESTED: 'Merchant not interested to speak',
}

export const RevisitRescheduleReason = {
  MERCHANT_ASKED_TO_COME_LATER: 'Merchant Asked to Come Later',
  MERCHANT_NON_CONTACTABLE: 'Merchant non contactable',
  MERCHANT_OUT_OF_STATION: 'Merchant out of Station',
  SHOP_PERMANENTLY_CLOSED: 'Shop Permanently Closed',
}

export const ACQUIRER_MAPPING = {
  '62': 'PINE_AXIS',
  '3': 'HDFC',
}

export function delay(t) {
  return new Promise((resolve) => setTimeout(resolve, t))
}

export const getRevisitNextPath = (status) => {
  switch (status) {
    case REVISIT_STATUS.LOCATION_DISCREPANCY_VALIDATED:
      return routes[Pages.RevisitFeedback]
    case REVISIT_STATUS.FEEDBACK_SUBMITTED:
    case REVISIT_STATUS.ACTIVATION_IN_PROGRESS:
      return routes[Pages.RevisitLoading]
    case REVISIT_STATUS.PRODUCTS_CONSUMPTION_PENDING:
      return routes[Pages.RevisitMapQR]
    case REVISIT_STATUS.REVISIT_COMPLETED:
      return routes[Pages.RevisitComplete]
    case REVISIT_STATUS.ACTIVATION_AND_MAPPING_COMPLETED:
      return routes[Pages.RevisitMapQR]
    case REVISIT_STATUS.PHOTO_PROOFS_UPLOADED:
      return routes[Pages.RevisitComplete]
    default:
      return routes[Pages.RevisitShopForm]
  }
}

export const statusSteps = {
  [REVISIT_STATUS.REVISIT_INITIATED]: 0,
  [REVISIT_STATUS.REVISIT_RESCHEDULED]: 0,
  [REVISIT_STATUS.REVISIT_INCOMPLETE]: 0,

  [REVISIT_STATUS.LOCATION_DISCREPANCY_VALIDATED]: 1,

  [REVISIT_STATUS.FEEDBACK_SUBMITTED]: 2,
  [REVISIT_STATUS.OPPORTUNITY_SF_SYNC_FAILED]: 2,
  [REVISIT_STATUS.PO_IMS_FAILED]: 2,
  [REVISIT_STATUS.DEPLOYMENT_CASE_CREATION_FAILED]: 2,

  [REVISIT_STATUS.PRODUCTS_CONSUMPTION_PENDING]: 3,
  [REVISIT_STATUS.ACTIVATION_IN_PROGRESS]: 3,

  [REVISIT_STATUS.ACTIVATION_AND_MAPPING_COMPLETED]: 4,

  [REVISIT_STATUS.PHOTO_PROOFS_UPLOADED]: 5,

  [REVISIT_STATUS.REVISIT_COMPLETED]: 6,
}

export function formatEmpCode(input) {
  if (!input) return ''
  const parts = input.split('-')
  const name = parts.slice(0, -1).join('-')
  const code = parts[parts.length - 1]
  return `${code}-${name}`
}
